export function About() {
  return (
    <main className="page container">
      <span className="eyebrow" style={{ marginBottom: 14 }}>
        <span className="dot" /> About
      </span>
      <h1>A Magic deck builder for fast, legal Arena-ready brews.</h1>
      <p className="muted" style={{ fontSize: "1.05rem", lineHeight: 1.65 }}>
        Foil Bloom pairs AI-assisted generation with a full card database to
        produce tournament-legal decklists from a plain-English description.
      </p>
      <p className="muted" style={{ lineHeight: 1.65 }}>
        Deck builds run through Foil Bloom's hosted backend. Card data is
        refreshed regularly, and legality is computed per-format from official
        Oracle text.
      </p>

      <div className="feature-grid" style={{ marginTop: 28 }}>
        <div className="feature-card">
          <span className="icon" aria-hidden>1</span>
          <h3>Extract the theme</h3>
          <p>
            Your deck description is passed to the LLM, which extracts an
            archetype, color identity, and a set of themes.
          </p>
        </div>
        <div className="feature-card">
          <span className="icon" aria-hidden>2</span>
          <h3>Gather candidates</h3>
          <p>
            We pull a candidate pool from the card database — filtered by
            format legality, sets, rarity caps, and Arena availability.
          </p>
        </div>
        <div className="feature-card">
          <span className="icon" aria-hidden>3</span>
          <h3>Assemble the list</h3>
          <p>
            The model assembles the decklist. We then validate and auto-repair
            any issues: over-copies, illegal lands, missing basics.
          </p>
        </div>
        <div className="feature-card">
          <span className="icon" aria-hidden>4</span>
          <h3>Write a play guide</h3>
          <p>
            A play guide — opening hand, turn-by-turn plan, matchup notes — is
            written for the final deck.
          </p>
        </div>
      </div>

      <div className="rationale-block" style={{ marginTop: 28 }}>
        <h3>Open-source tools used</h3>
        <ul style={{ lineHeight: 1.75, margin: 0, paddingLeft: 18 }}>
          <li>
            LLM tooling for deck generation and play-guide drafting
          </li>
          <li>
            <a href="https://fastapi.tiangolo.com" target="_blank" rel="noreferrer">FastAPI</a> + <a href="https://vitejs.dev" target="_blank" rel="noreferrer">Vite</a> + React for the application shell
          </li>
          <li>Firebase for authentication, Stripe for billing</li>
        </ul>
      </div>

      <p className="hint" style={{ marginTop: 28 }}>
        This app is not produced, endorsed, supported, or affiliated with
        Wizards of the Coast. Magic: The Gathering and all related card images
        are property of their respective rights holders.
      </p>
    </main>
  );
}
